import { render, staticRenderFns } from "./ProductsAdd.vue?vue&type=template&id=4ca5fe05&scoped=true&"
import script from "./ProductsAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAdd.vue?vue&type=style&index=0&id=4ca5fe05&lang=scss&scoped=true&"
import style1 from "./ProductsAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5fe05",
  null
  
)

export default component.exports